import TutorialModal from "@components/modals/TutorialModal/TutorialModal";
import { createContext, useContext, useState } from "react";

type TutorialContextType = {
    isTutorialModalOpened: boolean,
    openTutorialModal: (key: string) => void,
    closeTutorialModal: () => void,
};

export const TutorialContext = createContext<TutorialContextType>({
    isTutorialModalOpened: false,
    openTutorialModal: (key: string) => {},
    closeTutorialModal: () => {},
});

export const useTutorialContext = () => {
    return useContext(TutorialContext);
};

type TutorialModalProviderProps = {
    children: React.ReactNode,
};

export function TutorialModalProvider(props: TutorialModalProviderProps) {

    const [tutorialKey, setTutorialKey] = useState<string>('');
    const [tutorialVisible, setTutorialVisible] = useState<boolean>(false);

    const handleOpenTutorialModal = (key: string): void => {
        setTutorialKey(key);
        setTutorialVisible(true);
    };

    const handleCloseTutorialModal = (): void => {
        setTutorialVisible(false);
    };

    return (
        <TutorialContext.Provider value={{
            isTutorialModalOpened: false,
            openTutorialModal: handleOpenTutorialModal,
            closeTutorialModal: handleCloseTutorialModal,
        }}>
            <TutorialModal visible={tutorialVisible} onHide={handleCloseTutorialModal} tutorialKey={tutorialKey}/>
            {props.children}
        </TutorialContext.Provider>
    );
}
